import Example from './Example';
import LoadUserData from '../../LoadUserData';

export const ExampleConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     : '/example',
            component: LoadUserData(Example)
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/example/ExampleConfig.js